module.exports = __webpack_public_path__ + "media/images/svg/external-link-arrow-a6f5556fcb9eb4ae1ebb8702e224d5cf.svg";